export enum DataDownloadFormat {
  Csv = "csv",
  Json = "json",
  Xml = "xml",
}
